<div class="dialog-container" [class.no-action-buttons]="hideCancelBtn && hideSaveBtn">

  <div class="ebp-header flex flex-row justify-between items-center header-section" role="heading">
      <div class="mb-0">
        @if (isTitleTemplate) {
          <ng-container *ngTemplateOutlet="title"></ng-container>
        } @else {
          {{ title }}
        }
      </div>
      <button mat-icon-button type="button" tabindex="-1" (click)="closeDialog.emit()">
        <i class="fa-thin fa-xmark"></i>
      </button>
    </div>

  <mat-dialog-content>
    @if (isLoading$()) {
      <div class="sticky top-0 z-10 bg-white">
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      </div>
    }
    <ng-content></ng-content>
  </mat-dialog-content>

  @if (!hideCancelBtn || !hideSaveBtn) {
    <div mat-dialog-actions class="ebp-footer flex flex-row justify-end items-center gap-2">
      @if (!hideCancelBtn) {
        <button type="button" class="button-outline" [disabled]="cancelDisabledCondition" (click)="onCancel()">
          {{ cancelBtnTextCode | translate }}
        </button>
      }

      @if (!hideSaveBtn) {
        <button type="submit" [class]="customSaveBtnClass ?? 'button-regular'" [disabled]="saveDisabledCondition" (click)="save.emit()">
          @if (isSaveBtnTemplate) {
            <ng-container *ngTemplateOutlet="saveBtnTextCodeOrTemplate"></ng-container>
          } @else {
            {{ saveBtnTextCodeOrTemplate + '' | translate }}
          }
        </button>
      }
    </div>
  }
</div>
